// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BTDnvv57K8Y0nHGf2gaN{border:1px solid var(--border-brand-default);background:var(--light-blue-10);border-radius:6px;justify-content:space-between;align-items:center;width:100%;padding:12px 12px 12px 16px;display:flex}.MiH5wWwomKYdAthXX6Dl{align-items:center;gap:12px;display:flex}.flYobRiUQBk4W_6k5dhv{flex-direction:column;gap:6px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `BTDnvv57K8Y0nHGf2gaN`,
	"card__box": `MiH5wWwomKYdAthXX6Dl`,
	"cardBox": `MiH5wWwomKYdAthXX6Dl`,
	"card__info": `flYobRiUQBk4W_6k5dhv`,
	"cardInfo": `flYobRiUQBk4W_6k5dhv`
};
export default ___CSS_LOADER_EXPORT___;
